export default __webpack_public_path__ + "static/media/c.a4281dc6.jpg";